import { ShieldCheck } from "lucide-react"

const LOGO_URL = "https://unicornis-data.cowgoesmoo.org/unicornis-welcome.jpg"

export function GuildLogo({ className }: { className?: string }) {
  return (
    <img
      src={LOGO_URL}
      alt=""
      className={className ?? "size-8 rounded-xl object-cover shadow-sm"}
    />
  )
}

export function GuildShieldIcon({ className }: { className?: string }) {
  return (
    <div
      className={
        className ??
        "flex size-8 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm"
      }
    >
      <ShieldCheck className="size-4" strokeWidth={2.2} />
    </div>
  )
}
